import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface IDeleteElementDialogProps {
  title: string;
  text: string;
}

@Component({
    selector: 'app-delete-element-dialog',
    templateUrl: './delete-element-dialog.component.html',
    styleUrls: ['./delete-element-dialog.component.scss'],
    standalone: false
})
export class DeleteElementDialogComponent {
  title: string;
  text: string;

  constructor(
    public dialogRef: MatDialogRef<DeleteElementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: IDeleteElementDialogProps
  ) {
    this.title = data?.title ? data.title : $localize`:@@js_Delete:Eliminar`;
    this.text = data?.text ? data.text : $localize`:@@ConfirmDeletion:Realmente desea eliminarlo?`;
  }

  delete() {
    this.dialogRef.close(true);
  }
}
